import { Button, Heading, HFlow, VFlow } from 'bold-ui'
import theme from 'config/theme'
import React from 'react'

export const CancelarSolicitacaoEnvio = () => {
  return (
    <HFlow
      style={{
        border: `1px solid ${theme.pallete.divider}`,
        padding: '1rem',
      }}
      alignItems='flex-start'
    >
      <VFlow>
        <Heading level={3}>Solicitação enviada com sucesso</Heading>
        <p>A instalação destino recebeu sua solicitação de envio.</p>
      </VFlow>

      <Button size='small' skin='outline' kind='primary'>
        Cancelar solicitação
      </Button>
    </HFlow>
  )
}
